<div class="dialog dialog-small dialog-flex-direction-column">
    <h4 class="dialog-inner h4-blue">Cost of Living Benefit</h4>
    <div class="dialog-inner">Your calculated benefit will be increased by 5% each year beginning on
        the anniversary date of when you first qualified for benefits. In year 2,
        your benefit will be 105%, in year 3, 110.25%, etc, until benefits expire.
    </div>
    <div class="dialog-inner semibold">Additional Annual Cost</div>
    <div class="cost">{{cost ? (cost | currency) : 'Calculating...'}}</div>
    <!--
    <br />
    <mat-label class="label-text">Maximum Benefit Duration</mat-label>
    -->
    <br />
    <mat-form-field>
        <mat-label class="label-text">Maximum Duration</mat-label>
        <mat-select [(ngModel)]="COLADuration" [disabled]="COLADurationOptions.length <= 1"
            (selectionChange)="updateCost()">
            <mat-option *ngIf="COLADurationOptions.length <= 1" value="{{COLADuration}}">{{COLADuration}}</mat-option>
            @for ( item of COLADurationOptions; track item ) {
            <mat-option value="{{item}}">{{item}}</mat-option>
            }
        </mat-select>
    </mat-form-field>
    <!--<div class="dialog-inner">Would you like to add this benefit to your policy?</div> -->
    <div *ngIf="!inclusion()" class="dialog-inner-buttons">
        <button class="button-mgis" (click)="no()" class="chat-button chat-button-define" mat-flat-button>Cancel</button>
        <button class="button-mgis" (click)="yes()" class="chat-button chat-button-define" mat-flat-button>Add to Policy</button>

    </div>
    <div *ngIf="inclusion()" class="dialog-inner-buttons">
        <button class="button-mgis" (click)="yes()" class="chat-button chat-button-define" mat-flat-button>Close</button>
    </div>